// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Legal pages - same color palette as Landing */
.legal-page {
  --color-primary-dark: #1C0770;
  --color-primary: #261CC1;
  --color-secondary: #3A9AFF;
  --color-accent: #F1FF5E;
  --color-accent-text: #1a1a2e;

  --bg-main: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 50%, #f5f9ff 100%);
  --bg-header: rgba(255, 255, 255, 0.85);
  --bg-card: rgba(255, 255, 255, 0.9);
  --bg-cta: rgba(58, 154, 255, 0.12);
  --bg-footer: rgba(28, 7, 112, 0.08);

  --text-primary: #1a1a2e;
  --text-secondary: #4a4a6a;
  --text-muted: #6b6b8a;

  --border-card: rgba(38, 28, 193, 0.12);
  --shadow-card: 0 4px 24px rgba(28, 7, 112, 0.08);
}

.legal-page[data-theme="dark"] {
  --color-primary-dark: #5b4dff;
  --color-primary: #6b5cff;
  --color-secondary: #3A9AFF;
  --color-accent: #F1FF5E;
  --color-accent-text: #0f0f14;

  --bg-main: linear-gradient(135deg, #0f0f14 0%, #1a1a24 50%, #15151f 100%);
  --bg-header: rgba(26, 26, 36, 0.9);
  --bg-card: rgba(37, 37, 48, 0.8);
  --bg-cta: rgba(58, 154, 255, 0.15);
  --bg-footer: rgba(0, 0, 0, 0.3);

  --text-primary: #f0f0f5;
  --text-secondary: #b8b8c8;
  --text-muted: #8888a0;

  --border-card: rgba(255, 255, 255, 0.08);
  --shadow-card: 0 4px 24px rgba(0, 0, 0, 0.3);
}

.legal-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-main);
  transition: background 0.3s ease;
}

.legal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  background: var(--bg-header);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-card);
}

.legal-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.legal-logo:hover {
  opacity: 0.9;
}

.legal-logo-img {
  height: 40px;
  width: auto;
  object-fit: contain;
  display: block;
}

.legal-nav {
  display: flex;
  gap: 12px;
  align-items: center;
}

.legal-nav .nav-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s;
}

.legal-nav .nav-link:hover {
  color: var(--color-primary);
  background: var(--bg-cta);
}

.legal-nav .nav-link--primary {
  background: var(--color-primary);
  color: white;
}

.legal-nav .nav-link--primary:hover {
  background: var(--color-primary-dark);
  color: white;
}

.legal-nav .lang-selector,
.legal-nav .lang-trigger,
.legal-nav .lang-dropdown,
.legal-nav .lang-option,
.legal-nav .theme-toggle {
  /* Reuse Landing styles - import from Landing or duplicate minimal set */
}

.legal-main {
  flex: 1;
  padding: 40px 20px 60px;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

.legal-content {
  background: var(--bg-card);
  border-radius: 16px;
  padding: 40px;
  border: 1px solid var(--border-card);
  box-shadow: var(--shadow-card);
}

.legal-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 32px 0;
  padding-bottom: 20px;
  border-bottom: 2px solid var(--color-primary);
}

.legal-content h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 28px 0 12px 0;
}

.legal-content h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 20px 0 8px 0;
}

.legal-content p,
.legal-content li {
  font-size: 0.95rem;
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0 0 12px 0;
}

.legal-content ul {
  margin: 0 0 16px 0;
  padding-left: 24px;
}

.legal-content p:last-child {
  margin-bottom: 0;
}

.legal-footer {
  padding: 24px;
  text-align: center;
  background: var(--bg-footer);
  border-top: 1px solid var(--border-card);
}

.legal-footer-links {
  margin-bottom: 12px;
}

.legal-footer-links a {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: 500;
  padding: 0 8px;
}

.legal-footer-links a:hover {
  text-decoration: underline;
}

.legal-footer .footer-sep {
  color: var(--text-muted);
  margin: 0 4px;
}

.legal-footer p {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
}

/* Reuse theme/lang components from Landing */
.legal-nav .lang-selector {
  position: relative;
}

.legal-nav .lang-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid var(--border-card);
  border-radius: 10px;
  background: var(--bg-card);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.legal-nav .lang-trigger:hover {
  border-color: var(--color-secondary);
  background: var(--bg-cta);
}

.legal-nav .lang-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 180px;
  margin: 0;
  padding: 8px;
  list-style: none;
  background: var(--bg-card);
  border: 1px solid var(--border-card);
  border-radius: 12px;
  box-shadow: var(--shadow-card);
  z-index: 100;
}

.legal-nav .lang-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.legal-nav .theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: var(--bg-cta);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 18px;
}

.legal-nav .theme-toggle:hover {
  background: var(--color-secondary);
  color: white;
}

@media (max-width: 640px) {
  .legal-header {
    padding: 16px 20px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .legal-content {
    padding: 24px;
  }

  .legal-title {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LegalPageLayout.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;;EAE5B,yEAAyE;EACzE,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;;EAEnC,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;;EAE5B,yEAAyE;EACzE,kCAAkC;EAClC,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;;EAE/B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;;;;;EAKE,wEAAwE;AAC1E;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Legal pages - same color palette as Landing */\n.legal-page {\n  --color-primary-dark: #1C0770;\n  --color-primary: #261CC1;\n  --color-secondary: #3A9AFF;\n  --color-accent: #F1FF5E;\n  --color-accent-text: #1a1a2e;\n\n  --bg-main: linear-gradient(135deg, #f0f4ff 0%, #e8eeff 50%, #f5f9ff 100%);\n  --bg-header: rgba(255, 255, 255, 0.85);\n  --bg-card: rgba(255, 255, 255, 0.9);\n  --bg-cta: rgba(58, 154, 255, 0.12);\n  --bg-footer: rgba(28, 7, 112, 0.08);\n\n  --text-primary: #1a1a2e;\n  --text-secondary: #4a4a6a;\n  --text-muted: #6b6b8a;\n\n  --border-card: rgba(38, 28, 193, 0.12);\n  --shadow-card: 0 4px 24px rgba(28, 7, 112, 0.08);\n}\n\n.legal-page[data-theme=\"dark\"] {\n  --color-primary-dark: #5b4dff;\n  --color-primary: #6b5cff;\n  --color-secondary: #3A9AFF;\n  --color-accent: #F1FF5E;\n  --color-accent-text: #0f0f14;\n\n  --bg-main: linear-gradient(135deg, #0f0f14 0%, #1a1a24 50%, #15151f 100%);\n  --bg-header: rgba(26, 26, 36, 0.9);\n  --bg-card: rgba(37, 37, 48, 0.8);\n  --bg-cta: rgba(58, 154, 255, 0.15);\n  --bg-footer: rgba(0, 0, 0, 0.3);\n\n  --text-primary: #f0f0f5;\n  --text-secondary: #b8b8c8;\n  --text-muted: #8888a0;\n\n  --border-card: rgba(255, 255, 255, 0.08);\n  --shadow-card: 0 4px 24px rgba(0, 0, 0, 0.3);\n}\n\n.legal-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-main);\n  transition: background 0.3s ease;\n}\n\n.legal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 40px;\n  background: var(--bg-header);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid var(--border-card);\n}\n\n.legal-logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: opacity 0.3s ease;\n}\n\n.legal-logo:hover {\n  opacity: 0.9;\n}\n\n.legal-logo-img {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.legal-nav {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.legal-nav .nav-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.legal-nav .nav-link:hover {\n  color: var(--color-primary);\n  background: var(--bg-cta);\n}\n\n.legal-nav .nav-link--primary {\n  background: var(--color-primary);\n  color: white;\n}\n\n.legal-nav .nav-link--primary:hover {\n  background: var(--color-primary-dark);\n  color: white;\n}\n\n.legal-nav .lang-selector,\n.legal-nav .lang-trigger,\n.legal-nav .lang-dropdown,\n.legal-nav .lang-option,\n.legal-nav .theme-toggle {\n  /* Reuse Landing styles - import from Landing or duplicate minimal set */\n}\n\n.legal-main {\n  flex: 1;\n  padding: 40px 20px 60px;\n  max-width: 800px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.legal-content {\n  background: var(--bg-card);\n  border-radius: 16px;\n  padding: 40px;\n  border: 1px solid var(--border-card);\n  box-shadow: var(--shadow-card);\n}\n\n.legal-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 32px 0;\n  padding-bottom: 20px;\n  border-bottom: 2px solid var(--color-primary);\n}\n\n.legal-content h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 28px 0 12px 0;\n}\n\n.legal-content h3 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 20px 0 8px 0;\n}\n\n.legal-content p,\n.legal-content li {\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n  line-height: 1.7;\n  margin: 0 0 12px 0;\n}\n\n.legal-content ul {\n  margin: 0 0 16px 0;\n  padding-left: 24px;\n}\n\n.legal-content p:last-child {\n  margin-bottom: 0;\n}\n\n.legal-footer {\n  padding: 24px;\n  text-align: center;\n  background: var(--bg-footer);\n  border-top: 1px solid var(--border-card);\n}\n\n.legal-footer-links {\n  margin-bottom: 12px;\n}\n\n.legal-footer-links a {\n  color: var(--color-primary);\n  text-decoration: none;\n  font-weight: 500;\n  padding: 0 8px;\n}\n\n.legal-footer-links a:hover {\n  text-decoration: underline;\n}\n\n.legal-footer .footer-sep {\n  color: var(--text-muted);\n  margin: 0 4px;\n}\n\n.legal-footer p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--text-muted);\n}\n\n/* Reuse theme/lang components from Landing */\n.legal-nav .lang-selector {\n  position: relative;\n}\n\n.legal-nav .lang-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid var(--border-card);\n  border-radius: 10px;\n  background: var(--bg-card);\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.legal-nav .lang-trigger:hover {\n  border-color: var(--color-secondary);\n  background: var(--bg-cta);\n}\n\n.legal-nav .lang-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 180px;\n  margin: 0;\n  padding: 8px;\n  list-style: none;\n  background: var(--bg-card);\n  border: 1px solid var(--border-card);\n  border-radius: 12px;\n  box-shadow: var(--shadow-card);\n  z-index: 100;\n}\n\n.legal-nav .lang-option {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: left;\n}\n\n.legal-nav .theme-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: var(--bg-cta);\n  color: var(--text-primary);\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 18px;\n}\n\n.legal-nav .theme-toggle:hover {\n  background: var(--color-secondary);\n  color: white;\n}\n\n@media (max-width: 640px) {\n  .legal-header {\n    padding: 16px 20px;\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .legal-content {\n    padding: 24px;\n  }\n\n  .legal-title {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
